import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages'; 
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { useAuth } from './AuthContext';
import './Inscription.css';

// ══════════════════════════════════════════════════════════════
// PEFEP TECH — PAGE CONNEXION
// ══════════════════════════════════════════════════════════════

export default function Connexion() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [chargement, setChargement] = useState(false);
  const [erreur, setErreur] = useState('');

  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (erreur) setErreur('');
  };

  const handleConnexion = async (e) => {
    e.preventDefault();
    setErreur('');

    if (!formData.email.trim() || !formData.password.trim()) {
      setErreur('Email et mot de passe obligatoires');
      return;
    }
<SEO {...SEO_PAGES.connexion} />
    setChargement(true);

    try {
      // ────────────────────────────────────────────────────────
      // ÉTAPE 1 : Connexion Supabase Auth
      // ────────────────────────────────────────────────────────
      const { data, error } = await supabase.auth.signInWithPassword({
        email: formData.email,
        password: formData.password,
      });

      if (error) {
        if (error.message.includes('Invalid login credentials')) {
          setErreur('Email ou mot de passe incorrect');
        } else if (error.message.includes('Email not confirmed')) {
          setErreur('Email non confirmé. Vérifiez votre boîte de réception.');
        } else {
          setErreur('Erreur : ' + error.message);
        }
        setChargement(false);
        return;
      }

      if (!data?.user) {
        setErreur('Erreur inattendue lors de la connexion');
        setChargement(false);
        return;
      }

      // ────────────────────────────────────────────────────────
      // ÉTAPE 2 : Charger le profil dans AuthContext
      // ────────────────────────────────────────────────────────
      await login(data.user);

      // ────────────────────────────────────────────────────────
      // ÉTAPE 3 : Récupérer le type de compte pour la redirection
      // ────────────────────────────────────────────────────────
      const { data: profil } = await supabase
        .from('clients')
        .select('type_compte')
        .eq('id', data.user.id)
        .single();

      // ────────────────────────────────────────────────────────
      // ÉTAPE 4 : Redirection vers le tableau de bord (unifié)
      // ────────────────────────────────────────────────────────
      navigate('/tableau-de-bord');

    } catch (err) {
      console.error('Erreur inattendue :', err);
      setErreur('Erreur inattendue : ' + err.message);
      setChargement(false);
    }
  };

  return (
    <div className="inscription-container">
      {/* PARTIE GAUCHE — Branding PEFEP */}
      <div className="inscription-gauche">
        <div className="inscription-gauche-content">
          <div className="inscription-logo">PEFEP</div>
          <h1>Content de vous revoir !</h1>
          <p className="inscription-slogan">Là où vos idées rencontrent la tech</p>

          <div className="inscription-services">
            <div className="service-item">
              <span className="service-icone">🚀</span>
              <div>
                <strong>Reprenez là où vous vous êtes arrêté</strong>
                <span>Vos sites, projets et paramètres sont sauvegardés</span>
              </div>
            </div>
            <div className="service-item">
              <span className="service-icone">💼</span>
              <div>
                <strong>Accès à votre dashboard</strong>
                <span>Gérez vos sites, paiements et clients</span>
              </div>
            </div>
            <div className="service-item">
              <span className="service-icone">🎁</span>
              <div>
                <strong>Programme parrainage</strong>
                <span>Gagnez jusqu'à 20% en cash chaque mois</span>
              </div>
            </div>
            <div className="service-item">
              <span className="service-icone">📱</span>
              <div>
                <strong>Support 24/7</strong>
                <span>Notre équipe est disponible sur WhatsApp</span>
              </div>
            </div>
          </div>

          <div className="inscription-signature">
            <div className="signature-badge">🇭🇹 Made in Haïti</div>
          </div>
        </div>
      </div>

      {/* PARTIE DROITE — Formulaire */}
      <div className="inscription-droite">
        <div className="inscription-droite-content">
          <h2>Se connecter</h2>
          <p className="inscription-sous-titre">Accédez à votre espace PEFEP Tech</p>

          {erreur && (
            <div className="inscription-erreur">
              ⚠️ {erreur}
            </div>
          )}

          <form onSubmit={handleConnexion} className="inscription-form">
            <div className="form-champ">
              <label>✉ Email <span className="obligatoire">*</span></label>
              <input
                type="email"
                placeholder="exemple@email.com"
                value={formData.email}
                onChange={e => updateField('email', e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="form-champ">
              <label>🔒 Mot de passe <span className="obligatoire">*</span></label>
              <input
                type="password"
                placeholder="Votre mot de passe"
                value={formData.password}
                onChange={e => updateField('password', e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn-inscription"
              disabled={chargement}
            >
              {chargement ? '⏳ Connexion en cours...' : '🔐 Se connecter'}
            </button>

            <div className="inscription-mention">
              Mot de passe oublié ? Contactez-nous sur WhatsApp : +509 4737 6200
            </div>
          </form>

          <div className="inscription-lien-connexion">
            Pas encore de compte ? <Link to="/inscription">Créer un compte</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
